<template>
  <ul class="attachments">
    <li v-for="(item, index) in value" :key="item.id" class="attachments__item">
      <WIcon icon="icLink" />

      <a
        href="#"
        class="attachments__link"
        :title="item.fileName"
        @click.prevent="openLink(item, category)"
      >
        {{ item.fileName }}
      </a>
      <button
        v-if="!hideRemove"
        class="attachments__remove"
        @click="removeItem(index, item)"
      >
        <WIcon icon="icClose" />
      </button>
    </li>
  </ul>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'

import { HEALTH_EVENT_CATEGORY } from '@/models/healthEvents'
export default {
  components: { WIcon },
  inject: ['confirm', 'notify'],
  props: {
    value: { type: Array, default: undefined },
    category: { type: String, default: undefined },
    hideRemove: Boolean
  },
  emits: ['input'],
  methods: {
    async openLink(item, category) {
      try {
        if (item.link) return window.open(item.link, '_blank')
        const query =
          category === HEALTH_EVENT_CATEGORY.REFUND_REQUESTED
            ? '?shouldGetAsPii=true'
            : ''
        const url = `${process.env.VUE_APP_FILE_VAULT_API_PREFIX_URL}/file/${item.id}${query}`
        const file = await this.$store.dispatch('file/getFile', url)

        window.open(file.url, '_blank')
      } catch (error) {
        return this.notify('Não foi possivel abrir o arquivo.')
      }
    },
    async removeItem(index, item) {
      const confirmResponse = await this.confirm({
        title: `Deseja realmente excluir o anexo ${item.fileName}?`,
        ok: 'Excluir',
        cancel: 'Cancelar'
      })

      if (!confirmResponse) return

      const result = [...this.value]
      result.splice(index, 1)
      this.$emit('input', result)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.attachments {
  padding: 0 !important;

  &__item {
    align-items: center;
    background-color: var(--sys-color-surface-background-default);
    display: grid;
    gap: var(--gl-spacing-03);
    grid-template-columns: auto 1fr auto;
    margin: var(--gl-spacing-02) 0;
    padding: var(--gl-spacing-01) var(--gl-spacing-02);
    width: max-content;
    max-width: 380px;
    border-radius: var(--gl-border-radius-md);
  }

  &__link {
    @extend %body-default;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  &__remove {
    cursor: pointer;
  }
}
</style>
